import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './YouTubeEmbed.css';

const YouTubeEmbed = ({ channelId, videoId }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);
  const [hasError, setHasError] = useState(false);

  // Föredra exakt video-ID (managed broadcast) — pålitligt. Kanal-metoden
  // (embed/live_stream?channel=) är deprecated av YouTube och ger ofta
  // "This video is unavailable"; används bara som fallback.
  const embedUrl = videoId
    ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0&modestbranding=1`
    : channelId
    ? `https://www.youtube.com/embed/live_stream?channel=${channelId}&autoplay=1&mute=1&rel=0&modestbranding=1`
    : null;

  if (!embedUrl || hasError) {
    return null;
  }

  return (
    <div className={`youtube-embed-container ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="youtube-embed-header">
        <div className="stream-badge">
          <span className="stream-icon">📺</span>
          <span>LIVESTREAM</span>
        </div>
        <button
          className="toggle-stream-btn"
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? t('live.minimizeStream') : t('live.expandStream')}
        >
          {isExpanded ? `▼ ${t('live.minimize')}` : `▲ ${t('live.showStream')}`}
        </button>
      </div>

      {isExpanded && (
        <div className="youtube-embed-wrapper">
          <iframe
            src={embedUrl}
            title={t('live.streamTitle')}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            onError={() => setHasError(true)}
          />
        </div>
      )}
    </div>
  );
};

export default YouTubeEmbed;
